import breadcrumbs from './Ideas_bank_breadcrumbs';
import comments from './Idea_comments';
import orderby from 'lodash.orderby';
import api from '../../api/index';

export default {
  namespaced: true,
  modules   : {
    breadcrumbs,
    comments,
  },
  state: {
    themes: [

    ],
    modals: [
      {
        type  : 'ideas_bank_modal',
        active: false,
      },
      {
        type  : 'add_comment_modal',
        active: false,
      },
      {
        type  : 'edit_comment_modal',
        active: false,
      },
      {
        type  : 'delete_comment_modal',
        active: false,
      },
    ],
    ideas: [
      {
        id      : 1,
        title   : 'Решение проблемы хранения продукции…',
        date    : 1543093200000,
        likes   : 112,
        comments: 75,
        author  : {
          name   : 'Константин Константинопольский',
          avatar : '/images/avt-40-1.png',
          chevron: '/images/chevron.png',
          rank   : 'Ветеран',
        },
        theme: 'Оптимизация данных',
        text : 'Усовершенствован раздел «База знаний» на портале. Теперь можно скачивать материалы прямо на рабочий компьютер, телефон или планшет. Для реагистрации на портале необходимо запросить логин/пароль у своего…',
      },
    ],
    selected_theme : null,
    selected_number: 10,
    selected_page  : 1,
    sorting        : 'asc',
    search_string  : '',
    current_idea   : null,
  },
  getters: {
    ideas               : ({ideas}) => ideas,
    last_idea           : ({ideas}) => ideas[ideas.length-1],
    themes              : ({themes}) => themes,
    current_idea        : ({current_idea}) => current_idea,
    idea_detail         : ({ideas, current_idea}) => ideas.find((idea) => idea.id == current_idea),
    ideas_bank_modal    : ({modals}) => modals.find((modal)=> modal.type == 'ideas_bank_modal').active,
    add_comment_modal   : ({modals}) => modals.find((modal)=> modal.type == 'add_comment_modal').active,
    edit_comment_modal  : ({modals}) => modals.find((modal)=> modal.type == 'edit_comment_modal').active,
    delete_comment_modal: ({modals}) => modals.find((modal)=> modal.type == 'delete_comment_modal').active,
    selected_theme      : ({selected_theme}) => selected_theme,
    selected_number     : ({selected_number}) => selected_number,
    selected_page       : ({selected_page}) => selected_page,
    sorting             : ({sorting}) => sorting,
    search_string       : ({search_string}) => search_string,
    filtered_by_theme({ideas}, {selected_theme}) {
      if (selected_theme && selected_theme !== 'Все темы') {
        return ideas.filter((item)=> item.theme == selected_theme);
      } else {
        return ideas;
      }
    },
    search_by_string: ({selected_theme, ideas, search_string}, {filtered_by_theme})=> {
      if (selected_theme) {
        return filtered_by_theme.filter((x)=> x.title.toLowerCase().includes(search_string.toLowerCase()));
      } else {
        return ideas.filter((x)=> x.title.toLowerCase().includes(search_string.toLowerCase()));
      }
    },
    paginated({search_string}, {selected_number, filtered_by_theme, selected_page, sorting, search_by_string}) {
      let search_filtered = search_string ? search_by_string : filtered_by_theme;
      let asc = orderby(search_filtered, (o) => o.date, 'asc');
      let desc = orderby(search_filtered, (o) => o.date, 'desc');
      if (sorting == 'asc') {
        return asc.slice((selected_number*(selected_page-1)), selected_number*selected_page);
      } else if (sorting == 'desc') {
        return desc.slice((selected_number*(selected_page-1)), selected_number*selected_page);
      } else {
        return search_filtered.slice((selected_number*(selected_page-1)), selected_number*selected_page);
      }
    },
  },
  mutations: {
    CLOSE_MODAL(state, type) {
      let modal = state.modals.find((modal)=> modal.type === type);
      modal.active = false;
    },
    OPEN_MODAL(state, type) {
      let modal = state.modals.find((modal)=> modal.type === type);
      if (!modal.active) {
        modal.active = true;
      }
    },
    CURRENT_IDEA(state, value) {
      state.current_idea = value;
    },
    SET_SELECTED_THEME(state, value) {
      state.selected_theme = value;
    },
    SET_SELECTED_PAGE(state, value) {
      state.selected_page = value;
    },
    SHOW_NUMBER(state, obj) {
      const {array, selected} = obj;
      if (selected=='Показывать по 10') {
        state.selected_number = 10;
      } else if (selected=='Показывать по 25') {
        state.selected_number = 25;
      } else if (selected=='Показывать по 50') {
        state.selected_number = 50;
      } else if (selected=='Показывать по 100') {
        state.selected_number = 100;
      }
      if (array.length >= 10) {
        return array.slice(0, state.selected_number);
      } else {
        return array;
      }
    },
    SORT_BY_DATE(state, selected) {
      if (selected=='Сначала новые') {
        state.sorting = 'desc';
      } else if (selected=='Сначала старые') {
        state.sorting = 'asc';
      }
    },
    CLEAR_PAGES(state) {
      state.selected_page = 1;
    },
    SEND_IDEA(state, {idea}) {
      state.ideas.push(idea);
    },
    SEARCH_STRING(state, value) {
      state.search_string = value;
      state.selected_page = 1;
    },
    SET_IDEAS(state, ideas) {
      if (!ideas.ideas) {
        state.ideas=[];
      } else {
        state.ideas = ideas.ideas;
        state.ideas.forEach((x)=> x.date = x.date*1000);
      }
      state.themes = Object.values(ideas.themes);
      state.themes.unshift({id: '0', text: 'Все темы'});
    },
    TO_LIKED(state, idea) {
      idea.liked = !idea.liked;
      if (idea.liked) {
        idea.likes = parseInt(idea.likes, 10) + 1;
      } else {
        idea.likes = parseInt(idea.likes, 10) - 1;
      }
    },
  },
  actions: {
    show_number({commit, getters}, event) {
      const {filtered_by_theme} = getters;
      commit('CLEAR_PAGES');
      commit('SHOW_NUMBER', {array: filtered_by_theme, selected: event});
    },
    sorting_by_date({commit}, selected) {
      commit('SORT_BY_DATE', selected);
      commit('CLEAR_PAGES');
    },
    send_idea({commit, rootGetters, dispatch}, idea) {
      const user = rootGetters['profile/user/user'];
      let new_idea = {
        title   : idea.title,
        theme   : idea.theme,
        text    : idea.text,
        file    : idea.files,
        likes   : 0,
        comments: 0,
        author  : {
          name   : `${user.name} ${user.patronymic} ${user.family}`,
          avatar : user.avatar,
          rank   : user.rank || '',
          chevron: user.chevron || '',
        },
      };
      dispatch('post_idea', new_idea);
      commit('CLOSE_MODAL', 'ideas_bank_modal');
    },
    async get_ideas({commit}) {
      try {
        const ideas = await api.ideas_bank.get_ideas();
        commit('SET_IDEAS', ideas.data);
      } catch (err) {
        console.error(err);
      }
    },
    async post_idea({}, new_idea) {
      try {
        await api.ideas_bank.post_idea(new_idea);
      } catch (err) {
        console.error(err);
      }
    },
    async like_idea({state, commit}, id) {
      let likedIdea = state.ideas.find((idea) => idea.id == id);
      commit('TO_LIKED', likedIdea);
      try {
        if (likedIdea.liked) {
          await api.ideas_bank.like_idea(likedIdea.id);
        } else {
          await api.ideas_bank.unlike_idea(likedIdea.id);
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
};
